// import React from "react";
// import { Stack, Typography, Paper, useMediaQuery } from "@mui/material";
// import staffListData from "../../../src/data/administration/staffData.json";
// import { Call } from "@mui/icons-material";
// import EmailIcon from '@mui/icons-material/Email';

import { Box, Card } from "@mui/material"

// interface StaffMember {
//   sno: number;
//   cc?: string;
//   pno?: number;
//   name?: string;
//   education?: string;
//   designation?: string;
//   dob?: string;
//   mobile1?: string;
//   mobile2?: string;
//   email?: string;
//   // address?: string;
//   bloodGroup?: string;
// }

// const staffList: StaffMember[] = staffListData;

// const formatDate = (dob?: string) => {
//   if (!dob) return "N/A";
//   const date = new Date(dob);
//   return isNaN(date.getTime()) ? dob : date.toLocaleDateString();
// };

// const StaffDetails = () => {
//   const isSmallScreen = useMediaQuery("(max-width: 650px)");

//   return (
//     <div style={{ padding: "1rem" }}>
//       <Typography variant="h4" sx={{ fontFamily: "inherit", mb: 2, fontWeight: "bold" }}>
//         Staff Details
//       </Typography>

//       <Stack spacing={3}>
//         {staffList.map((staff: StaffMember) => (
//           <Paper
//             key={staff.sno}
//             elevation={3}
//             sx={{
//               padding: "1.5rem",
//               maxWidth:"500px",
//               backgroundColor: "#f5f5f5",
//               borderRadius: "8px",
//               boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.7)",
//               "&:hover":{transform:"scale(1.1)", boxShadow:"0px 4px 10px rgb(0, 0, 0)"},
//             }}
//           >
//             <Stack spacing={2}>
//               {/* SrNo, Name, PNO, Designation */}
//               <Stack direction="row" alignItems={"center"} flexWrap={"wrap"} gap={2}>
//                 <Typography sx={{ fontWeight: "light" }}>
//                   {staff.sno}
//                 </Typography>
//                 <Typography variant="body1" sx={{ fontWeight: "bold", fontSize:"" }}>
//                   {staff.name || "N/A"}
//                 </Typography>
//                 {staff.education && (
//                   <Typography variant="body1" sx={{ fontSize:"0.7rem" }}>
//                    ({staff.education || "N/A"})
//                   </Typography>
//                 )}
//                 <Typography variant="body1" sx={{ fontStyle: "italic", fontSize:"13px" }}>
//                   {staff.designation || "N/A"}
//                 </Typography>
//               </Stack>

//               {/* DOB, Mobile, Blood Group */}
//               {/* <Stack direction={{ xs: 'column', sm: 'row' }} gap={4} >
//                 <Typography variant="body2" >
//                    <strong>DOB:</strong> {formatDate(staff.dob)} 
//                 </Typography>
//                 <Typography variant="body2" >
//                   <Call sx={{ height: "12px", width: "12px" }} /> <a style={{ color: "black" }} href={`tel:${staff.mobile1}`}>{staff.mobile1 || "N/A"}</a>
//                 </Typography>
//                 <Typography variant="body2" >
//                   <Call sx={{ height: "12px", width: "12px" }} /> <a style={{ color: "black" }} href={`tel:${staff.mobile2}`}>{staff.mobile2 || "N/A"}</a>
//                  </Typography> */}
//                 {staff.email &&(
//                   <Typography variant="body2" >
//                   <EmailIcon  sx={{ height: "12px", width: "12px" }} /> <a style={{ color: "black" }} href={`email:${staff.email}`}>{staff.email || "N/A"}</a>
//                 </Typography>
//                 )}
//                 {/*<Typography variant="body2" >
//                   <strong>Blood Group:</strong> {staff.bloodGroup || "N/A"}
//                 </Typography>
//               </Stack>  */}

//               {/* Address */}
//               {/*<Typography variant="body2" sx={{ color: "gray" }}>
//                 <strong style={{ fontWeight: "bold" }}>Address:</strong> {staff.address || "N/A"}
//               </Typography> */}
//             </Stack>
//           </Paper>
//         ))}
//       </Stack>
//     </div>
//   );
// };

//export default StaffDetails;





// import React from "react";
// import { Box, Paper } from "@mui/material";

// const StaffDetails = () => {
//   // Add #toolbar=0&navpanes=0&scrollbar=0 to hide sidebar + top toolbar
//   const pdfUrl =
//     process.env.PUBLIC_URL +
//     "/assets/pdfs/staffDetails/White And Yellow Vibrant Meet The Team Instagram Post_20250922_081948_0000.pdf";

//   return (
//     <Box p={2} >
//       <Paper
//         elevation={4}
//         sx={{
//           borderRadius: 0,
//           overflow: "hidden",
//         }}
//       >
//         <iframe
//           src={pdfUrl}
//           width="100%"
//           height="800px"
//           style={{ border: "none"}}
//           title="Staff Details PDF"
//         />
//       </Paper>
//     </Box>
//   );
// };

// export default StaffDetails;



const StaffDetails = () => {
  const imgs = [
    { img: "/assets/images/staff photos/WhatsApp Image 2025-09-25 at 10.02.55 AM.jpeg", alt: "img1" },
    { img: "/assets/images/staff photos/WhatsApp Image 2025-09-25 at 10.02.57 AM.jpeg", alt: "img2" },
    { img: "/assets/images/staff photos/WhatsApp Image 2025-09-25 at 10.02.58 AM.jpeg", alt: "img3" },
    { img: "/assets/images/staff photos/WhatsApp Image 2025-09-25 at 10.02.59 AM.jpeg", alt: "img4" },
    { img: "/assets/images/staff photos/WhatsApp Image 2025-09-25 at 10.03.02 AM.jpeg", alt: "img5" },
    { img: "/assets/images/staff photos/WhatsApp Image 2025-09-25 at 10.03.03 AM.jpeg", alt: "img6" },
    { img: "/assets/images/staff photos/WhatsApp Image 2025-09-25 at 10.03.04 AM.jpeg", alt: "img7" },
    { img: "/assets/images/staff photos/WhatsApp Image 2025-09-25 at 10.03.04 AM (1).jpeg", alt: "img8" },
        { img: "/assets/images/staff photos/WhatsApp Image 2025-09-25 at 10.03.05 AM.jpeg", alt: "img9" },
    { img: "/assets/images/staff photos/WhatsApp Image 2025-09-25 at 10.03.05 AM (1).jpeg", alt: "img10" },

  ]
  return (

    <Card sx={{
      position: 'relative',
      overflow: 'hidden',
      height: "90%",
      width: "90%",
      objectFit: 'fill',
      borderRadius: '5px 5px 0 0',
      transition: 'transform 0.3s ease',
      '&:hover': {
        transform: 'scale(1.003)', // Slight zoom effect
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.7)',
      },
    }}>
      {
        imgs.map((item, id) => (
          <div key={item.alt}>
            <Box
              component="img"
              src={item.img}
              height="100%"
              width="100%"
              alt={item.alt}
            />
          </div>
        ))
      }
    </Card>

  )
}

export default StaffDetails